import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Applies a pushed `sms_status` worklist-socket event to the cached SMS
// history. We match the row by `message_id` (always present) rather than
// `patient_id` (may be null), updating whichever patient's cached list already
// contains it. `setQueriesData` only touches caches that already exist, so this
// never fabricates empty history for patients whose panel was never opened.
// The initial history still loads from the GET; this keeps it live thereafter.
var applySmsStatusEvent = function applySmsStatusEvent(queryClient, event) {
  if (!event || event.message_id == null) {
    return;
  }
  queryClient.setQueriesData(["smsPatientMessages"], function (messages) {
    if (!(messages !== null && messages !== void 0 && messages.some(function (m) {
      return m.id === event.message_id;
    }))) {
      return messages;
    }
    return messages.map(function (m) {
      var _event$failure_reason;
      return m.id === event.message_id ? _objectSpread(_objectSpread({}, m), {}, {
        status: event.status,
        status_label: event.status_label,
        // Present only on Failed; carry it through, else keep prior value.
        failure_reason: (_event$failure_reason = event.failure_reason) !== null && _event$failure_reason !== void 0 ? _event$failure_reason : m.failure_reason
      }) : m;
    });
  });
};
export default applySmsStatusEvent;